export default __webpack_public_path__ + "static/media/WorkDayPlanner.35dbd7fd.PNG";